import { Box } from '@deity/falcon-ui';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { MappingContext } from 'contexts/MappingContext';
import type { FC } from 'react';
import { useContext } from 'react';

interface DropInPanelProps {
  isHidden?: boolean;
  displayFn: () => boolean;
}
const DropInPanel: FC<DropInPanelProps> = ({ isHidden, displayFn, children }) => {
  const ctx = useContext(MappingContext);

  return (
    <ErrorBoundary>
      <Box
        boxShadow="subtle"
        bg="white"
        p="md"
        style={{
          position: 'fixed',
          right: 0,
          top: 96,
          width: '500px',
          height: 'calc(100vh - 167px',
          zIndex: 100,
          transition: 'all .2s ease-in-out',
          overflowY: 'scroll',
          transform: `translateX(${displayFn() && !isHidden ? 0 : 600}px)`
        }}
      >
        {children}
      </Box>
    </ErrorBoundary>
  );
};

export default DropInPanel;
